<template>
  <div class="audio-player-wrapper" v-if="audioUrl">
    <div class="audio-player">
      <div class="player-title">{{ taskTitle }} Recording:</div>
      <audio ref="audioElement" controls :src="audioUrl" class="audio-element"></audio>
      <button class="close-btn" @click="closePlayer">×</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudioPlayer',
  props: {
    audioUrl: {
      type: String,
      default: null
    },
    taskTitle: {
      type: String,
      default: 'Verbal Fluency'
    }
  },
  methods: {
    closePlayer() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.audio-player-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: white;
  padding: 10px 0;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
}

.audio-player {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 15px;
}

.player-title {
  font-weight: bold;
  margin-right: 15px;
  white-space: nowrap;
  color: #333;
}

.audio-element {
  flex-grow: 1;
  max-width: 600px;
}

.close-btn {
  background: none;
  border: none;
  color: #666;
  font-size: 24px;
  cursor: pointer;
  padding: 0 10px;
}

@media (max-width: 768px) {
  .audio-player {
    flex-direction: column;
    padding: 10px 15px;
  }
  
  .player-title {
    margin-bottom: 10px;
    margin-right: 0;
  }
  
  .audio-element {
    width: 100%;
    margin-bottom: 10px;
  }
  
  .close-btn {
    align-self: flex-end;
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style> 